import React from "react";
import styled from "styled-components";
import apron from "../images/home/apron.png";

const ApronHighlight = () => {
  return (
    <Wrapper>
      <ContentWrapper>

        {/* LEFT — IMAGE */}
        <ImageBox>
          <img src={apron} alt="Apron" />
        </ImageBox>

        {/* RIGHT — TEXT */}
        <TextBox>
          <Title>Jesus is the Bread of Life, Faith-Filled Apron</Title>

          <Description>
            Whip up some kitchen magic with a side of humor in this 
            “Jesus is the Bread of Life, I’m Just Making the Sandwiches” apron 
            from Gift To Inspire! With its playful bread graphic and cheeky slogan, 
            this organic cotton gem—available in bold red, sleek black, crisp white, 
            or cozy beige—brings faith and fun to every meal prep. Perfect for home chefs 
            who love a good laugh, it’s the ultimate gift for birthdays, housewarmings, 
            or any moment that calls for a smile.
            <br /><br />
            Tie it on, toss in some love, and let this apron spark joy and inspiration 
            in the heart of the kitchen. Grab yours and make every sandwich a masterpiece!
          </Description>

          <Button>Shop Now</Button>
        </TextBox>

      </ContentWrapper>
    </Wrapper>
  );
};

export default ApronHighlight;

const Wrapper = styled.section`
  padding: 50px 80px;
  background: #f8f8f8;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 60px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const ImageBox = styled.div`
  display: flex;
  justify-content: center;

  img {
    width: 85%;
    max-width: 450px;
    filter: drop-shadow(0 4px 12px rgba(0,0,0,0.15));
  }
`;

const TextBox = styled.div``;

const Title = styled.h2`
  font-size: 26px;
  color: #3d5553;
  margin-bottom: 20px;
  line-height: 1.3;
  font-weight: 600;
`;

const Description = styled.p`
  font-size: 14px;
  color: #3b4b48;
  line-height: 1.7;
  margin-bottom: 30px;
`;

const Button = styled.button`
  padding: 14px 40px;
  background: #3b4b48;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    opacity: 0.85;
  }
`;
